import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService, IDomainDict as IDomainDictBase, TDomainDict } from '@wephone-core/service/authentication';
import { StorageService } from '@wephone-core/service/storage.service';
import { FlexBaseComponent } from '@wephone-core-ui';
import { FormControl } from '@angular/forms';
import { SigninService } from '@wephone-session/service/signin.service';
import * as _ from 'lodash';
import { regexSearch } from '@wephone-utils';
import { FlexIvrSettings } from '@wephone-core/wephone-core.module';

interface IDomainDict extends IDomainDictBase {
  domain: string;
}

@Component({
  selector: 'app-enterprise-select',
  templateUrl: './enterprise-select.component.html',
  styleUrls: ['./enterprise-select.component.scss']
})
export class EnterpriseSelectComponent extends FlexBaseComponent implements OnInit {
  returnUrl: string;
  domainName = '';
  domainNames = [];
  domainEnterprises: any = {};
  hideBackButton = true;
  disabled = false;
  username: string;

  filterControl: FormControl = new FormControl();

  constructor(
    public router: Router,
    private route: ActivatedRoute,
    private authService: AuthenticationService,
    private storage: StorageService,
    private signinService: SigninService,
    private readonly settings: FlexIvrSettings
  ) {
    super();
    this.authService.getLastDomain().then((lastDomain: any) => {
      if (lastDomain) {
        this.hideBackButton = false;
      }
    });
  }

  async ngOnInit(): Promise<void> {
    this.route.queryParams.subscribe(
      params => {
        this.returnUrl = params['returnUrl'];
      }
    );
    // this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/dashboard';

    this.username = await this.storage.getDomainTempData('user_name', this.domainName);
    // this.loggerService.log('this.username', this.username);
    if (!this.username) {
      this.username = this.signinService.currentUserName;
    }
    // this.loggerService.log('this.username', this.username);

    if (!this.username) {
      this.backLogin();
    } else {
      this.signinService.setCurrentUserName(this.username);
      await this.loadDomains();
    }

    super.ngOnInit();
  }

  get filteredDomainNames(): string[] {
    const filterValue = (this.filterControl.value || '').trim();
    if (filterValue && filterValue.trim) {
      return this.domainNames.filter(d => regexSearch(d, filterValue) || (this.domainEnterprises[d] && regexSearch(this.domainEnterprises[d], filterValue)));
    }

    return this.domainNames;
  }

  private async loadDomains(): Promise<void> {
    let domainDict: TDomainDict;
    try {
      domainDict = await this.signinService.getDomainDict();
    } catch (e) {
      this.loggerService.error('Cannot get domain dict', e);
      this.authService.gotoLoginPage();
    }

    if (domainDict) {
      const enterpriseNames: IDomainDict[] = [];
      for (const key of Object.keys(domainDict)) {
        const enterpriseDomainDict: IDomainDictBase = (typeof domainDict[key] !== 'string' ? domainDict[key] : {
          name: domainDict[key],
          business_type: null
        }) as IDomainDictBase;

        enterpriseNames.push(_.extend(enterpriseDomainDict, {
          domain: key
        }));
      }

      enterpriseNames.sort((a, b) => {
        return a.name.localeCompare(b.name);
      });

      this.domainEnterprises = {};
      for (const enterpriseName of enterpriseNames) {
        this.domainEnterprises[enterpriseName.domain] = enterpriseName.name;
      }

      this.domainNames = Object.keys(this.domainEnterprises);
    }
  }

  async selectDomainName(domainName): Promise<void> {
    // await this.authService.setLastDomain(domainName);
    await this.signinService.gotoDomain(domainName, this.returnUrl);
  }

  backLogin(): void {
    this.domainName = undefined;
    this.authService.setLastDomain(this.domainName).then(
      resp => {
        this.router.navigate(['/s/signin'], { queryParams: { returnUrl: this.returnUrl } });
      }
    );
  }
}
